import { Switch } from "@material-tailwind/react";

export function SwitchLabel() {
  return <Switch label="Automatic Update" />;
}
